import Page from "components/Page";
import { useTheme } from "@mui/material/styles";
import { Stack, Typography } from "@mui/material";

import testa_pepper from "assets/images/testa_pepper.png";
import { useEffect, useState } from "react";
import PinCode from "../components/PinCode";
import { instanceIdAtom, pinAtom, tokenAtom } from "lib/globalState";
import { useRecoilState } from "recoil";
import { useHistory, useParams } from "react-router";
import MessagePage from "components/MessagePage";
import { firebase, fireRDB, functions } from "lib/firebase";
import CenteredText from "components/CenteredText";

import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import PepperOccupato from "./PepperOccupato";
import PepperOffline from "./PepperOffline";

export default function OnBoarding() {
	const theme = useTheme();
	const [error, setError] = useState();
	const {instanceId: instanceIdPar} = useParams();
	const [token, setToken] = useRecoilState(tokenAtom);
	const [instanceId, setInstanceId] = useRecoilState(instanceIdAtom);
	const [pin, setPin] = useRecoilState(pinAtom);
	const history = useHistory();
	const [openBackdrop, setOpenBackdrop] = useState(false);
	const [isOnline, setIsOnline] = useState(undefined);

	const handleToggle = () => {
		setOpenBackdrop(prev => !prev);
	};

	const makeRequest = () => {
		const makeToken = functions.httpsCallable("areax_maketoken");
		console.log("makeToken", instanceId);
		makeToken({instanceId})
		.then((result) => {
			const {token, error, tokenInfo} = result.data;
			if (token) {
				console.log("token", token);
				setToken(token);
			} else {
				console.log(error, tokenInfo);
				setError({error, tokenInfo});
			}
		}).catch((error) => {
			console.log(error);
		});
	};

	const onSubmitPin = async (pin) => {
		handleToggle();
		try {
			const parsedPin = parseInt(pin, 10);
			if (pin.length > 0 && !isNaN(parsedPin)) {
				const validatePin = functions.httpsCallable("areax_validatePin");
				console.log(`Validating pin ${pin} for token ${token} on ${instanceId}`);
				const res = await validatePin({pin: parsedPin, instanceId});
				console.log("validatePin", res.data);
				if (res.data.valid) {
					let myConnectionsRef = fireRDB.ref(`users/${token}/connections`);
					const lastOnlineRef = fireRDB.ref(`users/${token}/lastOnline`);
					let connectedRef = fireRDB.ref(".info/connected");
					connectedRef.on("value", (snap) => {
						if (snap.val() === true) {
							// We're connected (or reconnected)! Do anything here that should happen only if online (or on reconnect)
							var con = myConnectionsRef.push();

							// When I disconnect, remove this device
							con.onDisconnect().remove();

							// Add this device to my connections list
							// this value could contain info about the device or a timestamp too
							con.set(true);

							// When I disconnect, update the last time I was seen online
							lastOnlineRef.onDisconnect().set(firebase.database.ServerValue.TIMESTAMP);
						}
					});
					setPin(parsedPin);
					history.push(`/wall_loghi_piacere`);
				} else {
					if (res.data.error === "INVALID_PIN")
						setError("Attenzione, il codice inserito non è valido.");
					if (res.data.error === "TOKEN_EXPIRED") {
						setError("Attenzione, il codice inserito non è valido. Scansiona il codice QR");
					}
				}
			}
		} catch (e) {
			console.log(e);
		}
		handleToggle();
	};

	useEffect(() => {
		const newInstanceId = instanceIdPar || instanceId;
		if (newInstanceId) {
			setInstanceId(newInstanceId);
		}
	}, []);

	useEffect(() => {
		if (instanceId && isOnline) {
			makeRequest();
		}
	}, [instanceId, isOnline]);

	useEffect(() => {
		if (instanceId) {
			fireRDB.ref(`/robots/${instanceId}/online`).get().then((snapshot) => {
				setIsOnline(snapshot.exists() && snapshot.val());
			});
		}
	}, [instanceId]);

	/*useEffect(() => {
		let timeoutId
		if (error && !error.error) {
			timeoutId = setTimeout(() => {
				setError()
			}, 2500)
		}
		return () => {
			timeoutId && clearTimeout(timeoutId)
		}
	}, [error])*/

	return (
		instanceIdPar || instanceId ? (
			error?.error === "INSTANCE_BUSY" ? <PepperOccupato ms={error?.tokenInfo?.expiresIn} tokenInfo={error?.tokenInfo}/>
				:
				token && isOnline ? <Page bg={theme.palette.background.paper}>
						<Stack spacing={1} sx={{
							display: "flex",
							flex: 1
						}}>
							<CenteredText><img src={testa_pepper} alt="testa pepper"/></CenteredText>
							<CenteredText>
								<Typography variant="h2">Ciao!</Typography>
								<Typography variant="h5" sx={{paddingInline: "1.1rem", lineHeight: "2rem"}}>
									Per iniziare l’esperienza, inserisci entro 30 secondi, il codice presente sul tablet del robot dietro la
									vetrina:
								</Typography>
							</CenteredText>
							<CenteredText>
								<PinCode onSubmit={otp => onSubmitPin(otp)}/>
								<Typography variant="h6" color={theme.palette.error.main}>
									{typeof error === "string" ? error : ""}
								</Typography>
							</CenteredText>
						</Stack>
						<Backdrop
							sx={{color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1}}
							open={openBackdrop}
						>
							<CircularProgress color="inherit"/>
						</Backdrop>
					</Page> :
					isOnline === false ?
						<PepperOffline/>
						:
						<MessagePage message={"Caricamento..."}/>
		) : <MessagePage message={"Instanza non valida. Scannerizza qr da AreaX"}/>
	);
}
